import { useSyncExternalStore } from 'react';

/** Recherches récentes, gardées dans ce navigateur (10 au plus) */
const KEY = 'pjs-recent-searches';
const MAX = 10;
let listeners: (() => void)[] = [];
let cache: string[] | null = null;

function read(): string[] {
  if (cache) return cache;
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    cache = Array.isArray(v) ? v.filter((x) => typeof x === 'string').slice(0, MAX) : [];
  } catch {
    cache = [];
  }
  return cache;
}

function write(list: string[]) {
  cache = list;
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* navigation privée */
  }
  listeners.forEach((l) => l());
}

export function addRecentSearch(q: string) {
  const t = q.trim().slice(0, 120);
  if (t.length < 2) return;
  const low = t.toLowerCase();
  write([t, ...read().filter((x) => x.toLowerCase() !== low)].slice(0, MAX));
}

export const removeRecentSearch = (q: string) => write(read().filter((x) => x !== q));
export const clearRecentSearches = () => write([]);

export function useRecentSearches(): string[] {
  return useSyncExternalStore(
    (l) => {
      listeners.push(l);
      return () => {
        listeners = listeners.filter((x) => x !== l);
      };
    },
    read,
    read,
  );
}
